module.exports = __webpack_public_path__ + "img/lazhu1.875fbd27.png";